import { DIC } from "@/const/dic";
import { formatterTime } from "@/util/util";
import { baseUrl } from "@/config/env";

export const productOrderDetailsExpressOption = {
  align: "center",
  menuAlign: "center",
  headerAlign: "center",
  border: true,
  expand: false,
  stripe: false,
  showHeader: true,
  // align: 'center',
  index: false,
  selection: true,
  menu: true,
  page: true,
  addBtn: false,
  editBtn: false,
  delBtn: false,
  updateBtn: false,
  viewBtn: false,
  editTitle: "发货",
  updateBtnTitle: "确定",
  menuWidth: "300",
  labelWidth: "150",
  //menuType:'menu',
  defaultSort: {
    prop: "createTime",
    order: "descending",
  },
  column: [
    {
      label: "商品名称",
      prop: "goodsName",
      type: "input",
      width: "300",
      search: true,
      clearable: true,
      addVisdiplay: false,
      editVisdiplay: false,
    },
    {
      label: "商品数量",
      prop: "goodsCount",
      addVisdiplay: false,
      editVisdiplay: false,
    },
    {
      label: "订单金额(元)",
      prop: "orderAmount",
      addVisdiplay: false,
      editVisdiplay: false,
    },
    {
      label: "销售金额(元)",
      prop: "saleAmount",
      addVisdiplay: false,
      editVisdiplay: false,
    },
    {
      label: "收货人姓名",
      prop: "name",
      addVisdiplay: false,
      editVisdiplay: false,
    },
    {
      label: "收货人电话",
      prop: "mobile",
      width: "120",
      //solt: true,
      addVisdiplay: false,
      editVisdiplay: false,
    },
    {
      label: "收货地址",
      prop: "address",
      width: "300",
      // solt: true,
      overHidden: true,
      addVisdiplay: false,
      editVisdiplay: false,
    },
    {
      label: "下单时间",
      prop: "createTime",
      type: "datetime",
      width: "200",
      sortable: true,
      overHidden: true,
      format: "yyyy-MM-dd HH:mm:ss",
      addVisdiplay: false,
      editVisdiplay: false,
    },
    {
      label: "支付时间",
      prop: "payTime",
      type: "datetime",
      sortable: true,
      width: "200",
      format: "yyyy-MM-dd HH:mm:ss",
      addVisdiplay: false,
      editVisdiplay: false,
    },
    {
      label: "订单编号",
      prop: "orderNumber",
      type: "input",
      overHidden: true,
      addVisdiplay: false,
      editVisdiplay: false,
    },
    {
      label: "销售渠道",
      prop: "orderType",
      type: "select",
      overHidden: true,
      dicData: DIC.PRODUCT_ORDER_TYPE,
      addVisdiplay: false,
      editVisdiplay: false,
    },
    
    {
      label: "商品折扣",
      prop: "discountAmount",
      addVisdiplay: false,
      editVisdiplay: false,
    },
    {
      label: "商品规格",
      prop: "skuValue",
      width: "300",
      overHidden: true,
      addVisdiplay: false,
      editVisdiplay: false,
    },
    {
      label: "下单人类型",
      prop: "clientType",
      overHidden: true,
      solt: true,
      addVisdiplay: false,
      editVisdiplay: false,
    },
    {
      label: "下单人姓名",
      prop: "realName",
      overHidden: true,
      addVisdiplay: false,
      editVisdiplay: false,
    },
    {
      label: "下单人电话",
      prop: "orderMobile",
      overHidden: true,
      addVisdiplay: false,
      editVisdiplay: false,
    },
    {
      label: "推广人客户端类型",
      prop: "promoteClientType",
      overHidden: true,
      addVisdiplay: false,
      editVisdiplay: false,
      solt: true,
    },
    {
      label: "推广人名称",
      prop: "promoteName",
      overHidden: true,
      addVisdiplay: false,
      editVisdiplay: false,
    },
    {
      label: "推广人帐号",
      prop: "promoteAccount",
      overHidden: true,
      addVisdiplay: false,
      editVisdiplay: false,
    },
    {
      label: "商品推广人账号",
      prop: "goodsPromoteAccount",
      overHidden: true,
      addVisdiplay: false,
      editVisdiplay: false,
    },
    {
      label: "商品推广人名称",
      prop: "goodsPromoteName",
      addVisdiplay: false,
      editVisdiplay: false,
      overHidden: true,
    },
    {
      label: "商品推广金额",
      prop: "goodsPromoteAmount",
      addVisdiplay: false,
      overHidden: true,
      editVisdiplay: false,
    },
    {
      label: "优惠券名称",
      overHidden: true,
      prop: "couponName",
      addVisdiplay: false,
      editVisdiplay: false,
    },
    {
      label: "优惠券金额(元)",
      prop: "couponAmount",
      addVisdiplay: false,
      editVisdiplay: false,
    },
    {
      label: "推广佣金(元)",
      prop: "promoteAmount",
      addVisdiplay: false,
      editVisdiplay: false,
    },
    {
      label: "平台抽成(元)",
      prop: "platformAmount",
      addVisdiplay: false,
      editVisdiplay: false,
    },
    {
      label: "订单状态",
      prop: "status",
      overHidden: true,
      solt: true,
      addVisdiplay: false,
      editVisdiplay: false,
    },
    {
      label: "支付时间",
      prop: "startDate_endDate",
      type: "datetimerange",
      valueFormat: "timestamp",
      span: 24,
      search: true,
      hide: true,
      clearable: true,
      addVisdiplay: false,
      editVisdiplay: false,
      formatter: function(row, value, label, column) {
        return formatterTime(row.startTime) + "至" + formatterTime(row.endTime);
      },
    },
    {
      label: "配送方",
      prop: "deliveryMan",
      //solt: true,
      addVisdiplay: false,
      editVisdiplay: false,
    },
    {
      label: "配送费(元)",
      prop: "deliveryAmount",
      //solt: true,
      addVisdiplay: false,
      editVisdiplay: false,
    },
    // ,{
    //     label: '单号',
    //     prop: 'expressNumber',
    //     addVisdiplay: false,
    //     editVisdiplay: false
    // }
    {
      label: "物流公司",
      prop: "deliveryId",
      formsolt: true,
      hide: true,
      editVisdiplay: false,
    },
    {
      label: "快递单号",
      prop: "expressNumber",
      hide: true,
      editVisdiplay: false,
    },
    {
      label: "快递费用",
      prop: "amount",
      hide: true,
      editVisdiplay: false,
    },
    {
      label: "配送经销商",
      prop: "merchantDeliveryId",
      formsolt: true,
      hide: true,
      editVisdiplay: true,
    },
  ],
};
